import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const gulaGulaTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#af1d20',
    },
    secondary: {
      main: '#e2c300',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#af1d20',
    },
  },
};
